import { ContentBlock } from '@purpur/library';
import styled from 'styled-components';
import { match } from 'ts-pattern';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { BlockSection } from '../common/Common.styles';
import { ResponsiveImage } from '../common/ResponsiveImage';
import { BlockContentBackground, BlockContentCardBackground, ContentCardAlignment } from './model';

type backgroundVariantProps = {
    $backgroundVariant?: BlockContentBackground;
};

export const BlockContentSection = styled(BlockSection)<backgroundVariantProps>`
    background: ${({ $backgroundVariant }) =>
        match($backgroundVariant)
            .with('dark', () => getPurpurColor('backgroundToneOnTonePrimary'))
            .otherwise(() => 'none')};
`;

export const BlockContentStandaloneContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('1200')};

    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('1600')};
    `};
`;

type CardBackgroundProps = {
    $backgroundVariant?: BlockContentCardBackground;
};

export const ContentCardContainer = styled.div<CardBackgroundProps>`
    background: ${({ $backgroundVariant }) =>
        match($backgroundVariant)
            .with('dark', () => getPurpurColor('backgroundToneOnTonePrimary'))
            .with('white', () => getPurpurColor('functionalWhite'))
            .otherwise(() => 'none')};
`;

type AlignmentProps = {
    $alignment?: ContentCardAlignment;
};

export const StyledContentBlock = styled(ContentBlock)<AlignmentProps>`
    ${({ $alignment }) =>
        $alignment &&
        purpurMedia('lg')`
            flex-direction: ${$alignment === 'right' ? 'row-reverse' : 'row'};
        `};

    [class*='_purpur-content-block__list-item-icon'] {
        flex-shrink: 0;
    }
`;

export const ContentCardBadgeWrapper = styled.div`
    display: flex;
`;

export const StyledResponsiveImage = styled(ResponsiveImage)`
    img {
        display: block;
        width: 100%;
        height: auto;
    }
`;

export const ResponsiveIframeContainer = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
`;

export const ResponsiveIframe = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;

    border-radius: ${getPurpurBorder('radiusMd')};
    ${purpurMedia('md')`
        border-radius: ${getPurpurBorder('radiusLg')};
    `}
`;

export const Video = styled.video.attrs({ controls: true })`
    width: 100%;
`;

export const ImageCtasContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
    padding-top: ${getPurpurSpacing('250')};
`;
